import Component from "../Component";
import SessionFiltersGate from "../../../components/shared/filters/SessionFiltersGate";
import { SCHEDULE_TRANSIENT_PARAMS } from "../Component/constants/scheduleTypes";
import DateFiltersProvider from "../../../components/shared/filters/DateFilters/context";
import { ScheduleProvider } from "../Component/context/Schedule";
import { ScrollProvider } from "../Component/context/Scroll";
import { MenuProvider } from "../Component/context/Menu";

function Template() {
    return (
        <div className="tw-h-full tw-w-full tw-bg-white tw-rounded-lg">
            <SessionFiltersGate storageKey="traxxion-schedule:template" excludeParams={SCHEDULE_TRANSIENT_PARAMS}>
                <DateFiltersProvider urlParams={false} modes={["day", "week"]} mode="week">
                    <ScheduleProvider type="template">
                        <ScrollProvider>
                            <MenuProvider>
                                <Component />
                            </MenuProvider>
                        </ScrollProvider>
                    </ScheduleProvider>
                </DateFiltersProvider>
            </SessionFiltersGate>
        </div>
    );
}

export default Template;
